const handleWheel = (event) => { //Prevents the scroll-wheel from changing the value
    event.target.blur();
};
const handleKeyDown = (event) => { //Prevents the up/down arrow keys from changing the value
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
    }
};
const handleCtrlSKeyDown = (event, saveFunction, saveEnable) => { //Prevents the webbrowser's default save page dialogue and let's us run a designated function instead, saveEnable is if we don't want to actually want to run the function (at least not yet) and we only want to prevent the browser webpage save dialog or until we want to allow the user to save, for example if they ctrl+s but they made no changes then we don't want to run the function passed to it
    if ((event.ctrlKey || event.metaKey) && event.key === "s") {    //CTRL + S
        event.preventDefault();
        if (saveEnable && saveFunction) {
            saveFunction();
        }
    }
}
export { handleWheel, handleKeyDown, handleCtrlSKeyDown };